/**
 * @author Fernando FH
 */

 import PRM from "@/core/PermissionConstants";
 import  RouteConstants from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.COLPOSCOPY_PENDING.path,
  name: RouteConstants.COLPOSCOPY_PENDING.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/ColposcopyPendingService"),
    table: () => import("@/app/components/colposcopy/pending/ColposcopyPendingTable"),
    form: () => import("@/app/components/colposcopy/pending/ColposcopyPendingForm"),

    header: {
      icono: "mdi-crosshairs-gps",
      texto: "Pendientes | Colposcopia",
      textNew: "Atender | Colposcopia",
      textEdit: "Editar | Colposcopia",
      textView: "Visualizar | Colposcopia"
    },
    prm: PRM.MODULE_COLPOSCOPY_PENDING,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    saveButton: "Finalizar",
    labelDate: "Seleccione fecha",
    namePDF: "Colposcopia"
  },
};
